import React, { useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { FaTrash } from "react-icons/fa";
import Roles from "../../data/Roles";
import axiosInstance from "../../lib/axios";
import { toast } from "react-toastify";

export default function AddEditPopup({ customer, onClose }) {
    const [formData, setFormData] = useState({
        email: customer?.email || '',
        role: customer?.role || '',
        password: '',
        firstName: customer?.firstName || '',
        lastName: customer?.lastName || '',
        organization: customer?.organization || '',
        country: customer?.country || '',
        phone: customer?.phone || '',
        phoneCode: customer?.phoneCode || '',
        industry: customer?.industry || '',
        locale: customer?.locale || '',
        timezone: customer?.timezone || '',
        aizoData: {
            viWeeks: customer?.aizoData?.viWeeks || '',
            painPoints: customer?.aizoData?.painPoints || [],
            companySize: customer?.aizoData?.companySize || '',
            sprintWeeks: customer?.aizoData?.sprintWeeks || '',
            digitalAiSkills: customer?.aizoData?.digitalAiSkills || [],
            technologyDeployed: customer?.aizoData?.technologyDeployed || [],
            businessOpportunities: customer?.aizoData?.businessOpportunities || []
        },
        status: customer?.status || ''
    });
  
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleAizoDataChange = (e, field, index) => {
        const { value } = e.target;
        setFormData((prevData) => {
            const updatedArray = [...prevData.aizoData[field]];
            updatedArray[index] = value; // Update the specific index in the array
            return {
                ...prevData,
                aizoData: {
                    ...prevData.aizoData,
                    [field]: updatedArray
                }
            };
        });
    };

    const handleArrayChange = (field) => {
        setFormData((prevData) => ({
            ...prevData,
            aizoData: {
                ...prevData.aizoData,
                [field]: [...prevData.aizoData[field], ''] // Add an empty string to the array
            }
        }));
    };

    const handleArrayRemove = (index, field) => {
        setFormData((prevData) => ({
            ...prevData,
            aizoData: {
                ...prevData.aizoData,
                [field]: prevData.aizoData[field].filter((_, i) => i !== index)
            }
        }));
    };

    const handleSubmit = () => {
        try {
            const response = axiosInstance.post("/admin/users", formData)
            toast.success("User added successfully!");
            onClose(); 
        } catch (error) {
            console.log(error)
        }
      
    };
    const handleEdit = async () => {
        try {
            const response = await axiosInstance.put(`/admin/users/${customer.id}`, formData);
                toast.success("User updated successfully!");
                onClose();           
        } catch (error) {
            toast.error("Failed to save user data.");
            console.error("Error during form submission:", error);
        }
    };
    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-4/5 md:w-1/2 p-6 max-h-[70vh] overflow-y-auto">
                <div className='flex justify-between items-center'>
                    <h2 className="text-lg font-semibold mb-4">{customer ? 'Edit User' : 'Add User'}</h2>
                    <button onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                <form>
                    {/* General Information */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Role</label>
                        <select
                            name="role"
                            value={formData.role}
                            onChange={handleInputChange}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        >
                            <option value="">Select a role</option>
                            {Object.values(Roles).map((role) => (
                                <option key={role} value={role}>{role.replace('_', ' ')}</option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">First Name</label>
                        <input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Last Name</label>
                        <input type="text" name="lastName" value={formData.lastName} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Password</label>
                        <input type="password" name="password" value={formData.password} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Locale</label>
                        <input type="text" name="locale" value={formData.locale} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Time Zone</label>
                        <input type="text" name="timezone" value={formData.timezone} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    {/* Phone Number Field */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>

                    {/* Phone Code Field */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Phone Code</label>
                        <input
                            type="text"
                            name="phoneCode"
                            value={formData.phoneCode}
                            onChange={handleInputChange}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>

                    {/* Industry Field */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Industry</label>
                        <input
                            type="text"
                            name="industry"
                            value={formData.industry}
                            onChange={handleInputChange}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Country</label>
                        <input type="text" name="country" value={formData.country} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Status</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        >
                            <option value="">Select a status</option>
                            <option value="Active">Active</option>
                            <option value="Disactive">Disactive</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Organization</label>
                        <input type="text" name="organization" value={formData.organization} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Company Size</label>
                        <input
                            type="number"
                            name="companySize"
                            value={formData.aizoData.companySize}
                            onChange={(e) => {
                                const { value } = e.target;
                                // Ensure value is numeric and update the formData
                                setFormData(prevData => ({
                                    ...prevData,
                                    aizoData: {
                                        ...prevData.aizoData,
                                        companySize: value
                                    }
                                }));
                            }}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Sprint Weeks</label>
                        <input
                            type="number"
                            name="sprintWeeks"
                            value={formData.aizoData.sprintWeeks}
                            onChange={(e) => {
                                const { value } = e.target;
                                // Ensure value is numeric and update the formData
                                setFormData(prevData => ({
                                    ...prevData,
                                    aizoData: {
                                        ...prevData.aizoData,
                                        sprintWeeks: value
                                    }
                                }));
                            }}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">ViWeeks</label>
                        <input
                            type="number"
                            name="viWeeks"
                            value={formData.aizoData.viWeeks}
                            onChange={(e) => {
                                const { value } = e.target;
                                // Ensure value is numeric and update the formData
                                setFormData(prevData => ({
                                    ...prevData,
                                    aizoData: {
                                        ...prevData.aizoData,
                                        viWeeks: value
                                    }
                                }));
                            }}
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                        />
                    </div>
                    {/* AizoData Fields (Array handling) */}
                    <div className="mb-4">
                        <div className=" flex justify-between items-center">
                            <label className="block text-sm font-medium text-gray-700">Pain Points</label>
                            <button type="button" onClick={() => handleArrayChange('painPoints')} className="btn bg-indigo-500 hover:bg-indigo-600  text-white">
                              
                                <svg
                                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                            </button>
                        </div>
                       
                        {formData.aizoData.painPoints.map((item, index) => (
                            <div key={index} className="flex items-center mt-2">
                                <input type="text" value={item} onChange={(e) => handleAizoDataChange(e, 'painPoints', index)} className="block w-full border-gray-300 rounded-md shadow-sm" />
                                
                                <button type="button" onClick={() => handleArrayRemove(index, 'painPoints')} className="ml-2 text-red-500">
                                    <FaTrash />
                                </button>
                            </div>
                        ))}
                    </div>

                    <div className="mb-4">
                        <div className=" flex justify-between items-center">
                            <label className="block text-sm font-medium text-gray-700">Digital AI Skills</label>
                            <button type="button" onClick={() => handleArrayChange('digitalAiSkills')} className="btn  bg-indigo-500 hover:bg-indigo-600 text-white">
                                
                                <svg
                                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                            </button>
                        </div>
                       
                        {formData.aizoData.digitalAiSkills.map((item, index) => (
                            <div key={index} className="flex items-center mt-2">
                                <input type="text" value={item} onChange={(e) => handleAizoDataChange(e, 'digitalAiSkills', index)} className="block w-full border-gray-300 rounded-md shadow-sm" />
                                <button type="button" onClick={() => handleArrayRemove(index, 'digitalAiSkills')} className="ml-2 text-red-500">
                                    <FaTrash />
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="mb-4">
                        <div className=" flex justify-between items-center">
                            <label className="block text-sm font-medium text-gray-700">Technology Deployed</label>
                            <button type="button" onClick={() => handleArrayChange('technologyDeployed')} className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                                <svg
                                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                            </button>
                        </div>
                        
                        {formData.aizoData.technologyDeployed.map((item, index) => (
                            <div key={index} className="flex items-center mt-2">
                                <input type="text" value={item} onChange={(e) => handleAizoDataChange(e, 'technologyDeployed', index)} className="block w-full border-gray-300 rounded-md shadow-sm" />
                                <button type="button" onClick={() => handleArrayRemove(index, 'technologyDeployed')} className="ml-2 text-red-500">
                                    <FaTrash />
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="mb-4">
                        <div className=" flex justify-between items-center">
                            <label className="block text-sm font-medium text-gray-700">Business Opportunities</label>
                            <button type="button" onClick={() => handleArrayChange('businessOpportunities')} className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                                <svg
                                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                            </button>
                        </div>
                       
                        {formData.aizoData.businessOpportunities.map((item, index) => (
                            <div key={index} className="flex items-center mt-2">
                                <input type="text" value={item} onChange={(e) => handleAizoDataChange(e, 'businessOpportunities', index)} className="block w-full border-gray-300 rounded-md shadow-sm" />
                                <button type="button" onClick={() => handleArrayRemove(index, 'businessOpportunities')} className="ml-2 text-red-500">
                                    <FaTrash />
                                </button>
                            </div>
                        ))}
                    </div>
                   
                    <button type="button" onClick={customer ?handleEdit :handleSubmit} className=" btn w-full flex-grow bg-indigo-500 hover:bg-indigo-600 text-white"
                    >{customer ? 'Edit User' : 'Add User'}</button>
                </form>
            </div>
        </div>
    );
}
